import styled from 'styled-components';

interface ContactProps {
  selected?: boolean;
}

interface ButtonProps {
  background?: string;
  color?: string;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  padding: 40px 20px 28px 20px;

  .title {
    width: 360px;
    height: 28px;
    margin-bottom: 20px;
  }

  .subtitle {
    width: 440px;
    height: 16px;
    margin-bottom: 30px;
  }

  .contract {
    width: 624px;
    height: 100px;
    margin-bottom: 10px;
  }

  .info2 {
    width: 624px;
    height: 60px;
    margin-top: 20px;
  }

  @media screen and (max-width: 960px) {
    .title {
      width: 300px;
    }

    .subtitle {
      width: 335px;
    }

    .contract {
      width: 335px;
      height: 90px;
    }

    .info2 {
      width: 335px;
      height: 70px;
    }
  }
`;

export const Buttons = styled.div`
  width: 100%;
  max-width: 624px;
  display: flex;
  justify-content: space-between;

  .button {
    width: 125px;
    height: 60px;
    margin-top: 10px;
  }

  @media screen and (max-width: 960px) {
    max-width: 335px;
  }
`;

export const Content = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Header = styled.div`
  width: 100%;
  button {
    font-size: 30px;
  }
`;
export const DivInputContainer = styled.div<{
  error: boolean;
  bottom?: string;
}>`
  flex-direction: column;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.18);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  align-items: center;
  height: 72px;
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '28px')};
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};
`;

export const TagError = styled.div`
  position: relative;
  z-index: 20;
  padding: 2px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  bottom: 10px;
  margin: 0 auto;
`;
export const Input = styled.input`
  width: 100%;
  height: 100%;
  text-align: center;
  border: none;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 140%;

  ::placeholder {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 140%;
    opacity: 0.2;
  }
`;
export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  h1 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.primaryDark1};
  }

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    color: #070c2f;
    margin-top: 34px;
    margin-bottom: 16px;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #222;
    text-align: center;
    line-height: 31px;
  }

  @media screen and (max-width: 960px) {
    h1 {
      font-size: 24px;
    }

    p {
      font-size: 16px;
      text-align: center;
      line-height: 21px;
    }
  }
`;

export const ButtonContainer = styled.div<{ singleButton: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ singleButton }) =>
    singleButton ? 'center' : 'space-between'};
  margin-top: 20px;
  width: 30vw;
`;

export const Button = styled.button<ButtonProps>`
  font-weight: 700;
  font-size: 16px;
  padding: 0 24px;
  height: 60px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  cursor: pointer;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};

  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  width: 100%;
  margin-top: 24px;
  svg {
    width: 32px;
  }

  div {
    margin: 5px;
    color: ${(props) => props.theme.colors.gray};
  }
`;
